const PORTAL_NAMES = {
  ADMIN: 'Admin Portal',
  ERP: 'ERP Home Page',
  SALES: 'Sales Portal',
  BIODIRECT: 'Biodirect Portal',
  OPERATION: 'Operation digitalization',
  SUPPORT: 'Support Portal',
  SERVICE: 'Services & Distribution Portal (S&D)',
  QMS: 'Quality Management System Portal (QMS)',
};

const LANGUAGES = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Español',
    code: 'es',
  },
  {
    name: 'Turkish',
    code: 'tr',
  },
];

export { LANGUAGES, PORTAL_NAMES };
